export default {
    attribute:{img:null,activeImg:null,alarmConfig:{operator:'>',threshold:60}, cptTableData: [{ "name": "指标", "value": "", "namekey": "value" }]},
    interaction:{eventText:'鼠标聚焦时'},
    cptDataForm: {dataText: '{"value":66}', dataSource: 1, pollTime: 0},
}